import React from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  Grid,
  Header,
  Image,
  Loader,
  Menu,
  Segment,
  Table,
} from "semantic-ui-react";
import { connect, useSelector } from "react-redux";
import Invitations from "../Invitations";
import { useAccount } from "../../../../../../../contexts/AccountContext";

const EnterpriseAccount = ({ user }) => {
  const { account } = useAccount();

  if (!isLoaded(accountData)) return <Loader />;
  if (isEmpty(accountData)) return null;

  const numberOfUsers = Object.keys(account.users).length;

  return (
    <>
      <Grid.Row>
        <Grid.Column>
          <Segment>
            <Header size={"large"} content={"Enterprise Plan"} />
            <p>
              You are currently paying for {numberOfUsers} seat
              {numberOfUsers > 1 ? "s" : ""}.
            </p>
          </Segment>
        </Grid.Column>
      </Grid.Row>
      {account && (
        <Invitations accountID={user.current_account_id || user.account} />
      )}
    </>
  );
};

EnterpriseAccount.propTypes = {
  user: PropTypes.object,
};

const mapStateToProps = ({ firebase }) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(EnterpriseAccount);
